"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var mainTable = document.querySelector("table");
var tableHead = mainTable.querySelector("thead");
var tableBody = mainTable.querySelector("tbody");
var currentColumnIndex = null;
var isAscending = true;
tableHead.addEventListener("click", function(e) {
    var _tableBody;
    var clicktedEvent = e.target;
    if (clicktedEvent.tagName !== "TH") return;
    var headTh = _to_consumable_array(tableHead.querySelectorAll("th"));
    var positionTh = headTh.indexOf(clicktedEvent);
    var bodyTr = _to_consumable_array(tableBody.querySelectorAll("tr"));
    if (currentColumnIndex === positionTh) isAscending = !isAscending;
    else {
        currentColumnIndex = positionTh;
        isAscending = true;
    }
    var sortedBody = bodyTr.sort(function(a, b) {
        var rowA = a.cells[positionTh].textContent;
        var rowB = b.cells[positionTh].textContent;
        if (positionTh <= 2) {
            var result = rowA.localeCompare(rowB);
            return isAscending ? result : rowB.localeCompare(rowA);
        } else {
            var cleanA = rowA.replaceAll("$", "").replaceAll(",", "");
            var cleanB = rowB.replaceAll("$", "").replaceAll(",", "");
            return isAscending ? cleanA - cleanB : cleanB - cleanA;
        }
    });
    (_tableBody = tableBody).append.apply(_tableBody, _to_consumable_array(sortedBody));
});
tableBody.addEventListener("click", function(e) {
    var clicktedEvent = e.target.closest("tr");
    if (!clicktedEvent) return;
    var activeTr = tableBody.querySelector(".active");
    if (activeTr) activeTr.classList.remove("active");
    clicktedEvent.classList.add("active");
});
var tableForm = document.createElement("form");
tableForm.classList.add("new-employee-form");
tableForm.innerHTML = '\n  <label>Name: <input name="name" type="text" data-qa="name"></label>\n  <label>Position: <input name="position" type="text" data-qa="position"></label>\n  <label>Office:\n    <select name="office" data-qa="office">\n      <option value="Tokyo">Tokyo</option>\n      <option value="Singapore">Singapore</option>\n      <option value="London">London</option>\n      <option value="New York">New York</option>\n      <option value="Edinburgh">Edinburgh</option>\n      <option value="San Francisco">San Francisco</option>\n    </select>\n  </label>\n  <label>Age: <input name="age" type="number" data-qa="age"></label>\n  <label>Salary: <input name="salary" type="number" data-qa="salary"></label>\n  <button type="submit">Save to table</button>\n';
mainTable.after(tableForm);
tableForm.addEventListener("submit", function(e) {
    e.preventDefault();
    var formName = tableForm.elements.name.value.trim();
    var formPosition = tableForm.elements.position.value.trim();
    var formOffice = tableForm.elements.office.value;
    var formAge = tableForm.elements.age.value;
    var formSalary = tableForm.elements.salary.value;
    if (!formName || !formPosition || !formOffice || !formAge || !formSalary) {
        pushNotification("Empty field!", "error");
        return;
    }
    if (formName.length < 4) {
        pushNotification("Small name!", "error");
        return;
    }
    if (formAge < 18 || formAge > 90) {
        pushNotification("No valid age!", "error");
        return;
    }
    var newTr = document.createElement("tr");
    var formattedSalary = "$".concat(Number(formSalary).toLocaleString("en-US"));
    newTr.innerHTML = "\n    <td>".concat(formName, "</td>\n    <td>").concat(formPosition, "</td>\n    <td>").concat(formOffice, "</td>\n    <td>").concat(formAge, "</td>\n    <td>").concat(formattedSalary, "</td>\n  ");
    tableBody.append(newTr);
    pushNotification("Congratulations!", "success");
    tableForm.reset();
});
var pushNotification = function(message, type) {
    var notification = document.createElement("div");
    notification.classList.add("notification", type);
    notification.dataset.qa = "notification";
    var notificationTitle = document.createElement("h2");
    var notificationText = document.createElement("p");
    notificationTitle.textContent = type;
    notificationText.textContent = message;
    notification.append(notificationTitle);
    notification.append(notificationText);
    document.body.append(notification);
    setTimeout(function() {
        notification.remove();
    }, 2000);
};
tableBody.addEventListener("dblclick", function(e) {
    var clickedTd = e.target;
    if (clickedTd.tagName !== "TD") return;
    var cellInput = tableBody.querySelector(".cell-input");
    if (cellInput) return;
    var clickedText = clickedTd.textContent;
    var newInput = document.createElement("input");
    newInput.classList.add("cell-input");
    newInput.value = clickedText;
    clickedTd.textContent = "";
    clickedTd.append(newInput);
    newInput.focus();
    newInput.addEventListener("blur", function() {
        var newValue = newInput.value.trim();
        if (newValue.length === 0) clickedTd.textContent = clickedText;
        else clickedTd.textContent = newValue;
    });
    newInput.addEventListener("keydown", function(ev) {
        if (ev.key === "Enter") newInput.blur();
    });
});

//# sourceMappingURL=index.dfbbd7cd.js.map
